// eslint-disable-next-line import/no-anonymous-default-export
export default {
  title: 'Recurring Payment Analysis',
  subtitle: 'Recurring payment statistics',
  totalPayments: 'Total Payments',
  activePayments: 'Active Payments',
  monthlyRevenue: 'Monthly Revenue',
  yearlyRevenue: 'Yearly Revenue',
  byFrequency: 'By Frequency',
  byType: 'By Type',
  byCompany: 'By Company',
  noData: 'No data',
  fetchError: 'Data could not be retrieved',
  currency: 'Currency',
  year: 'Year',
  monthSelection: 'Month Selection',
  allMonths: 'All Months',
  companyFilter: 'Company Filter',
  allCompanies: 'All Companies',
  packageType: 'Package Type',
  allTypes: 'All Types',
  includeServerCosts: 'Include Server Costs',
  monthlyAnalysis: 'Monthly Analysis',
  byCustomer: 'By Customer',
  byPackageType: 'By Package Type',
  selectedMonthDetail: 'Selected Month Detail',
  totalPurchase: 'Total Purchase',
  totalSale: 'Total Sale',
  totalProfit: 'Total Profit',
  purchase: 'Purchase',
  sale: 'Sale',
  profit: 'Profit',
  profitLoss: 'Profit/Loss',
  paymentCount: 'Payment Count',
  monthlyChart: 'Monthly Chart',
  monthlyTable: 'Monthly Table',
  month: 'Month',
  detailedPayments: 'Detailed Payments',
  goBack: 'Go Back',
  company: 'Company',
  package: 'Package',
  type: 'Type',
  frequency: 'Frequency',
  domain: 'Domain',
  packageName: 'Package Name',
  packageTypeText: 'Package Type',
  purchasePrice: 'Purchase Price',
  purchaseCurrency: 'Purchase Currency',
  salePrice: 'Sale Price',
  saleCurrency: 'Sale Currency',
  startDate: 'Start Date',
  nextPayment: 'Next Payment',
  paymentProbability: 'Payment Probability',
  monthlyPurchaseTRY: 'Monthly Purchase (TL)',
  monthlySaleTRY: 'Monthly Sale (TL)',
  yearlyPurchaseTRY: 'Yearly Purchase (TL)',
  yearlySaleTRY: 'Yearly Sale (TL)',
  noPaymentsForMonth: 'No payments found for this month',
  serverCosts: 'Server Costs',
  server: 'Server',
  unknownCompany: 'Unknown Company',
  unknownCustomer: 'Unknown Customer',
  unassignedCustomer: 'Unassigned',
  byCompanyAnalysis: 'Analysis by Company',
  byCustomerAnalysis: 'Analysis by Customer',
  byPackageTypeAnalysis: 'Analysis by Package Type',
  customer: 'Customer'
};
